import * as React from "react";
import ErrorScreen from "components/common/ErrorScreen";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { ui } from "aaa";

export const PocketsFeatureNotAvailableError = () => (
    <ErrorScreen
        useWebVersion
        externalInterfaceStore={externalInterfaceStore}
        message={ui.__("pockets.featureNotAvailable.message")}
        buttonLabelId="common.backToGeorgeGo"
    />
);


// WEBPACK FOOTER //
// ./src/components/pockets/PocketsFeatureNotAvailableError.tsx